<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <!-- {{ tabs }} -->
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="所属管线"
                prop="pipelineId"
              >
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  @change="pipelineIdChange"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in pipelineList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs !== '5' && tabs !== '6'"
            >
              <a-form-item
                label="请选择设备"
                prop="deviceIds"
              >
                <a-select
                  mode="multiple"
                  v-model="queryParam.deviceIds"
                  style="width: 100%"
                  placeholder="请选择设备"
                  @change="handleChange"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceList"
                    :key="item.id"
                    :value="item.id"
                    :title="item.deviceName+' - '+ item.locationDescription"
                  >
                    {{ item.deviceName }} - {{ item.locationDescription }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 1 || tabs == 3"
            >
              <a-form-item
                label="查询类型"
                prop="queryType"
              >
                <a-select
                  v-model="queryParam.queryType"
                  placeholder="查询类型"
                  allow-clear
                  @change="handleChanges"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in options"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 2 || tabs == 4 || tabs == 7"
            >
              <a-form-item
                label="查询类型"
                prop="queryType"
              >
                <a-select
                  v-model="queryParam.queryType"
                  placeholder="查询类型"
                  allow-clear
                  @change="handleChanges"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in option"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 5 || tabs == 6"
            >
              <a-form-item
                label="查询类型"
                prop="queryType"
              >
                <a-select
                  v-model="queryParam.queryType"
                  placeholder="查询类型"
                  allow-clear
                  @change="handleChanges"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in optionY"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 5"
            >
              <a-form-item
                label="选择时间(本次电位分析)"
                prop="queryType"
              >
                <a-range-picker
                  show-time
                  v-model="value"
                  style="width: 100%;"
                  @change="handleChangeTime"
                >
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 5"
            >
              <a-form-item
                label="选择时间(对比电位分析)"
                prop="queryType"
              >
                <a-range-picker
                  show-time
                  v-model="value2"
                  style="width: 100%;"
                  @change="handleChangeTimes"
                >
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 5"
            >
              <a-form-item
                label="电流范围(对比电位分析)"
                prop="queryType"
              >
                <div class="fanwei">
                  <a-input
                    v-model="queryParam.startCurrentRangeContrast"
                    placeholder="开始"
                    allow-clear
                  />
                  <a-input
                    v-model="queryParam.endCurrentRangeContrast"
                    placeholder="结束"
                    allow-clear
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 5"
            >
              <a-form-item
                label="电流范围(本次电位分析)"
                prop="queryType"
              >
                <div class="fanwei">
                  <a-input
                    v-model="queryParam.startCurrentRange"
                    placeholder="开始"
                    allow-clear
                  />
                  <a-input
                    v-model="queryParam.endCurrentRange"
                    placeholder="结束"
                    allow-clear
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="tabs == 2 || tabs == 4 || tabs == 6 || tabs == 7"
            >
              <a-form-item
                label="选择时间"
                prop="pipelineId"
              >
                <a-range-picker
                  @change="onChange"
                  v-model="value1"
                  v-if="queryParam.queryType == 1"
                />
                <a-range-picker
                  show-time
                  v-model="value1"
                  style="width: 100%;"
                  @change="onChange"
                  v-if="queryParam.queryType == 0"
                >
                  <!-- <a-range-picker
                    show-time
                    v-model="value1"
                    style="width: 100%;"
                    v-if="queryParam.queryType == 0"
                  > -->

                </a-range-picker>
                <div v-if="queryParam.queryType == 2 || queryParam.queryType == 3">
                  <a-range-picker
                    :placeholder="queryParam.queryType == 2 ? ['开始月', '结束月'] : ['开始年', '结束年']"
                    :format="queryParam.queryType == 2 ? 'YYYY-MM' : 'YYYY'"
                    v-model="value1"
                    :open="monthPickShow"
                    :mode="queryParam.queryType == 2 ? ['month', 'month'] : ['year', 'year']"
                    @panelChange="handlePanelChange2"
                    @openChange="handleOpenChange"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="getPages"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-tabs
          default-active-key="1"
          @change="callback"
        >
          <a-tab-pane
            key="1"
            tab="实时电位"
          >
            <div>
              <div
                class="pubLoading"
                v-show="!showLoading"
              >
                <a-icon
                  slot="indicator"
                  type="loading"
                  style="font-size: 80px"
                  spin
                />
              </div>
              <div v-show="showLoading">
                <div v-if="list && list.length">
                  <div
                    v-for="(item, index) in list"
                    :key="index"
                  >
                    <lineChart :chartData="item.chartData"></lineChart>
                  </div>
                </div>
                <div
                  class="kong"
                  v-else
                >
                  <img
                    src="~@/assets/images/kong.png"
                    alt=""
                  >
                  <div>暂无数据</div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="2"
            tab="历史电位"
            force-render
          >
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>
            <div v-show="showLoading">
              <div v-if="list && list.length">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <lineChart15 :chartData="item.chartData"></lineChart15>
                </div>
              </div>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="3"
            tab="实时交流电压"
          >
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>
            <div v-show="showLoading">
              <div v-if="list && list.length">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <lineChart2 :chartData="item.chartData"></lineChart2>
                </div>
              </div>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="4"
            tab="历史交流电压"
          >
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>
            <div v-show="showLoading">
              <div v-if="list && list.length">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <lineChart2 :chartData="item.chartData"></lineChart2>
                </div>
              </div>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="5"
            tab="季度电位分析"
          >
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>
            <div v-show="showLoading">
              <lineChart9
                :chartData="chartData"
                v-if="chartData.locationDescription && chartData.locationDescription.length"
              ></lineChart9>
              <lineChart10
                :chartData="chartDatas"
                v-if="chartDatas.locationDescription && chartDatas.locationDescription.length"
              ></lineChart10>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>

          </a-tab-pane>
          <a-tab-pane
            key="6"
            tab="管线电位/交流电压分布"
          >
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>
            <div v-show="showLoading">
              <lineChart11
                :chartData="chartData"
                v-if="chartData && chartData.time && chartData.time.length"
              ></lineChart11>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="7"
            tab="电流分布图"
          >
            <!-- <div v-show="!showLoading">
              <div v-if="list && list.length">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <lineChart7
                    :chartData="item.chartData"
                    v-if="item.chartData && item.time && item.time.length"
                  ></lineChart7>
                </div>
              </div>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div> -->
            <div
              class="pubLoading"
              v-show="!showLoading"
            >
              <a-icon
                slot="indicator"
                type="loading"
                style="font-size: 80px"
                spin
              />
            </div>

            <div v-show="showLoading">
              <div v-if="list && list.length">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <lineChart7 :chartData="item.chartData"></lineChart7>
                </div>
              </div>
              <div
                class="kong"
                v-else
              >
                <img
                  src="~@/assets/images/kong.png"
                  alt=""
                >
                <div>暂无数据</div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDeviceData, listPipeline, listDevice, chartOne, chartTwo, chartThree, chartFour, chartFive, chartSix, chartSeven } from '@/api/saifuneng/devicedata'
import { tableMixin } from '@/store/table-mixin'
import lineChart from '../../Charts/lineChart.vue'
import lineChart2 from '../../Charts/lineChart2.vue'
import lineChart7 from '../../Charts/lineChart7.vue'
import lineChart9 from '../../Charts/lineChart9.vue'
import lineChart10 from '../../Charts/lineChart10.vue'
import lineChart11 from '../../Charts/lineChart11.vue'
import lineChart15 from '../../Charts/lineChart15.vue'
import moment from 'moment'
export default {
  name: 'DeviceData',
  components: {
    lineChart,
    lineChart2,
    lineChart7,
    lineChart9,
    lineChart10,
    lineChart11,
    lineChart15
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      pipelineList: [],
      showLoading: true,
      deviceList: [],
      selectedRowKeys: [],
      chartData: {},
      monthPickShow: false,
      chartDatas: {},
      selectedRows: [],
      optionsX: [],
      options: [{
        id: 1,
        name: '30分钟'
      }, {
        id: 2,
        name: '1小时'
      }, {
        id: 3,
        name: '3小时'
      }, {
        id: 4,
        name: '6小时'
      }, {
        id: 5,
        name: '9小时'
      }, {
        id: 6,
        name: '24小时'
      }],
      option: [{
        id: 0,
        name: '即时'
      }, {
        id: 1,
        name: '日'
      }, {
        id: 2,
        name: '月'
      }, {
        id: 3,
        name: '年'
      }],
      optionY: [{
        id: 0,
        name: '平均值'
      }, {
        id: 1,
        name: '最小值'
      }, {
        id: 2,
        name: '最大值'
      }],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      tabs: 1,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pipelineId: undefined,
        deviceIds: [],
        queryType: 6
      },
      value: [],
      value2: [],
      value1: []

    }
  },
  filters: {
  },
  created () {
    this.getPage()
    this.getPipelineList()
    // this.getDeviceList(null)
  },
  computed: {
  },
  watch: {
  },
  methods: {
    callback (key) {
      this.showLoading = true
      console.log(key);
      this.list = []
      this.tabs = key
      console.log(key, '大大大大大');
      if (key == 1 || key == 3) {
        this.queryParam.queryType = 6
      } else if (key == 2 || key == 4 || key == 7) {
        this.queryParam.queryType = 1
        this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm')
        this.queryParam.startTime = moment(new Date()).subtract(3, 'day').startOf('day').format('YYYY-MM-DD HH:mm')
        this.value1 = [this.queryParam.startTime, this.queryParam.endTime]
        this.$forceUpdate()
      } else if (key == 5) {
        let end = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        let start = moment(new Date()).subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.endTime = end
        this.queryParam.startTime = start
        this.value = [start, end]
        this.queryParam.endTimeContrast = end
        this.queryParam.startTimeContrast = start
        this.value2 = [start, end]
        console.log(this.value2, 'value2value2value2');
        this.queryParam.queryType = 0
        this.$forceUpdate()
      } else if (key == 6) {
        this.queryParam.queryType = 0
        this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm')
        this.queryParam.startTime = moment(new Date()).subtract(3, 'day').startOf('day').format('YYYY-MM-DD HH:mm')
        this.value1 = [this.queryParam.startTime, this.queryParam.endTime]
        console.log(this.value1, 'ddd滴滴滴滴滴滴=====');
        this.$forceUpdate()
      }
      // this.getPage()
    },
    onChange (e) {
      this.queryParam.startTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm')
      this.queryParam.endTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm')
    },
    handleChangeTime (e) {
      this.queryParam.startTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    handleChangeTimes (e) {
      this.queryParam.startTimeContrast = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTimeContrast = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    handleChanges (e) {
      // this.getPage()
      // this.list = []
      if (this.tabs == 2 || this.tabs == 4) {
        if (e == 0) {
          this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment(new Date()).subtract(0, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 1) {
          this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment(new Date()).subtract(3, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 2) {
          this.queryParam.endTime = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
          this.queryParam.startTime = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 3) {
          this.queryParam.endTime = moment().endOf('year').format('YYYY-MM-DD HH:mm:ss');
          this.queryParam.startTime = moment().startOf('year').format('YYYY-MM-DD HH:mm:ss')
        }
        this.value1 = [this.queryParam.startTime, this.queryParam.endTime]
      }
    },
    getPages () {
      this.showLoading = false
      this.getPage()
      this.$forceUpdate()
    },
    getPage () {

      // this.showLoading = false
      if (this.queryParam.deviceIds.length == 0) return
      // if ((this.tabs ！== '5' || this.tabs ！== '6') && this.queryParam.deviceIds.length === 0) return
      if (this.tabs == 1) {
        // 实时电位
        chartOne(this.queryParam).then(res => {
          res = res.data
          this.getDate(res.dataList, 1, res)
        })
      } else if (this.tabs == 2) {
        // 历史电位
        chartTwo(this.queryParam).then(res => {
          res = res.data
          this.getDate(res.dataList, 2, res)
        })
      } else if (this.tabs == 3) {
        // 实时交流电压
        chartThree(this.queryParam).then(res => {
          res = res.data
          console.log(res, 'dddd嘟嘟嘟嘟');
          this.getDate(res.dataList, 3, res)
        })
      } else if (this.tabs == 4) {
        // 历史交流电压
        chartFour(this.queryParam).then(res => {
          res = res.data
          console.log(res, 'dddd嘟嘟嘟嘟');
          this.getDate(res.dataList, 4, res)
        })
      } else if (this.tabs == 5) {
        // 季度电位分析
        chartFive(this.queryParam).then(res => {
          res = res.data
          let chartData = {
            locationDescription: [],
            electrifiedPotential: [],
            voff: [],
            limitMax1: res.limitMax1,
            limitMax2: res.limitMax2,
            limitMin1: res.limitMin1,
            limitMin2: res.limitMin2,
          }
          let chartDatas = {
            locationDescription: [],
            acInterferenceVoltage: [],
            acCurrentDensity: [],
          }
          res.dataList.forEach(v => {
            // v.chartData = {
            //   locationDescription: [],
            //   electrifiedPotential: [],
            //   electrifiedPotentialContrast: [],
            // }
            // v.chartDatas = {
            //   locationDescription: [],
            //   acCurrentDensityContrast: [],
            //   acInterferenceVoltage: [],
            //   acInterferenceVoltageContrast: [],
            // }
            chartData.locationDescription.push(v.locationDescription)
            chartData.electrifiedPotential.push(v.electrifiedPotential ? v.electrifiedPotential : 0)
            chartData.voff.push(v.voff ? v.voff : 0)
            chartDatas.locationDescription.push(v.locationDescription)
            chartDatas.acInterferenceVoltage.push(v.acInterferenceVoltage ? v.acInterferenceVoltage : 0)
            chartDatas.acCurrentDensity.push(v.acInterferenceVoltageContrast ? v.acInterferenceVoltageContrast : 0)
          })
          this.chartData = chartData
          this.chartDatas = chartDatas
          this.showLoading = true
          console.log(chartData, 'chartDatachartDatachartDatachartData');
          console.log(res, 'ddddddddaddddmm===');
        })
      } else if (this.tabs == 6) {
        // let query = {
        //   title: { text: '2010全国宏观经济指标' },
        //   series: [
        //     { data: dataMap.dataGDP['2010'] },
        //     { data: dataMap.dataFinancial['2010'] },
        //     { data: dataMap.dataEstate['2010'] },
        //     { data: dataMap.dataPI['2010'] },
        //     { data: dataMap.dataSI['2010'] },
        //     { data: dataMap.dataTI['2010'] }
        //   ]
        // }
        // 交流电压分布
        chartSix(this.queryParam).then(res => {
          res = res.data
          let chants = {
            time: [],
            options: [],
            x: []
          }
          res.dataList.forEach(v => {
            chants.time.push(v.dateStr)
            v.x = []
            let y1 = v.chartDataList.map(item => item.y1)
            let y2 = v.chartDataList.map(item => item.y2)
            let y3 = v.chartDataList.map(item => item.y3)
            let x = v.chartDataList.map(item => item.x)
            chants.x = x
            chants.options.push({ series: [{ data: y1 }, { data: y2 }, { data: y3 }] })
            // chants.options({ series: arr })
          })
          setTimeout(() => {
            this.chartData = chants
            this.showLoading = true
            console.log(chants, 'chants.optionschants.optionschants.optionschants.options');
          }, 100)


        })
      } else if (this.tabs == 7) {
        // 电流分布图
        chartSeven(this.queryParam).then(res => {
          res = res.data
          console.log(res, 'resresres=======');
          this.getDate(res.dataList, 7, res)
        })
      }
    },
    handleOpenChange (status) {
      if (status) {
        this.monthPickShow = true;
      } else {
        this.monthPickShow = false
      }
    },
    handlePanelChange2 (value, mode) {
      if (this.value1[1] && this.value1[1]._d != value[1]._d) {
        this.monthPickShow = false;
      }
      this.value1 = value;
      console.log(value, 'valuevaluevalue===');
      this.queryParam.startTime = moment(value[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(value[1]).format('YYYY-MM-DD HH:mm:ss')
      // this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    },
    getDate (date, e, res) {
      date.forEach(v => {
        console.log(v, '大大大大大===')
        let arr = []
        let arr1 = []
        let arr2 = []
        let time = []
        let sacrificialAnodeVoltage = []
        let selfCorrosionPotential = []
        v.chartDataList.forEach(item => {

          time.push(item.x)
          if (e == 3 || e == 4) {
            arr.push(item.y)
          } else {
            arr.push(item.y1)
            arr1.push(item.y2)
          }
          if (e == 2) {
            sacrificialAnodeVoltage.push(item.sacrificialAnodeVoltage)
            selfCorrosionPotential.push(item.selfCorrosionPotential)
          }
          if (e == 7) {
            arr2.push(item.y3)
          }
        })
        if (e == 1 || e == 2) {
          v.chartData = {
            time: time,
            y1: arr,
            y2: arr1,
            name: v.locationDescription,
            limitMax1: res.limitMax1,
            limitMax2: res.limitMax2,
            limitMin1: res.limitMin1,
            limitMin2: res.limitMin2,
          }
          if (e == 2) {
            v.chartData.selfCorrosionPotential = selfCorrosionPotential
            v.chartData.sacrificialAnodeVoltage = sacrificialAnodeVoltage

          }
        } else if (e == 3 || e == 4) {
          v.chartData = {
            time: time,
            y1: arr,
            name: v.locationDescription,
            limitMax1: res.limitMin,
            limitMax2: res.limitMax,
          }
        } else if (e == 7) {
          v.chartData = {
            time: time,
            y1: arr,
            y2: arr1,
            y3: arr2
          }
        }
        console.log(v.chartData, res, '111chartDatachartData')
      })
      console.log(this.list, 'chartDatachartData')
      this.list = res.dataList
      this.showLoading = true
      this.$forceUpdate()
    },
    /** 查询设备信息列表 */
    getList () {
      this.loading = true
      pageDeviceData(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getPage()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        pipelineId: undefined,
        deviceIds: [],
        queryType: 6,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    handleChange (e) {
      console.log(e, '大大大大大');
      if (e.length) {
        this.getPage()
      }
    },
    pipelineIdChange (value) {
      this.getDeviceList(value)
      this.queryParam.deviceId = null
    },
    getDeviceList (pipelineId) {
      listDevice({ "pipelineId": pipelineId }).then(response => {
        this.deviceList = response.data
        if (response.data.length) {
          this.queryParam.deviceIds = [response.data[0].id]
          console.log(this.queryParam, '大大大大大=========');
          // this.getPage()
        } else {
          this.queryParam.deviceIds = []
        }
        console.log(response.data, 'response.dataresponse.data');
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }

  }
}
</script>
<style lang="less" scoped>
.fanwei {
  display: flex;
  align-items: center;


  .ant-input-affix-wrapper {
    &:first-child {
      margin-right: 10px;
    }
  }
}

.kong {
  text-align: center;
}

.pubLoading {
  text-align: center;
}
</style>
